import { workspaceSectionPath } from "@/constants/routes";
import { PlanBadge } from "@/components/shared/status-badge";
import { cn } from "@/lib/utils";
import type { WorkspaceWithMembership } from "@bizy/core";
import { Building2, Check, ChevronsUpDown } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export interface WorkspaceSwitcherProps {
  workspaces: readonly WorkspaceWithMembership[];
  activeWorkspaceId?: string;
  className?: string;
}

export const WorkspaceSwitcher = ({
  workspaces,
  activeWorkspaceId,
  className,
}: WorkspaceSwitcherProps) => {
  const [open, setOpen] = useState(false);
  const active = workspaces.find((workspace) => workspace.id === activeWorkspaceId) ?? workspaces[0];

  return (
    <div className={cn("relative", className)}>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex w-full items-center justify-between gap-2 rounded-lg border border-border bg-card px-3 py-2 text-left text-sm hover:bg-muted"
      >
        <span className="flex min-w-0 items-center gap-2">
          <Building2 className="size-4 text-muted-foreground" aria-hidden />
          <span className="truncate font-medium">{active?.name ?? "Select workspace"}</span>
        </span>
        <ChevronsUpDown className="size-4 text-muted-foreground" aria-hidden />
      </button>

      {open ? (
        <div className="absolute left-0 right-0 z-50 mt-2 overflow-hidden rounded-lg border border-border bg-popover p-1 shadow-elevated">
          {workspaces.map((workspace) => (
            <Link
              key={workspace.id}
              to={workspaceSectionPath(workspace.slug, "home")}
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-2 rounded-md px-3 py-2 text-sm hover:bg-muted"
            >
              <span className="flex min-w-0 items-center gap-2">
                {workspace.id === active?.id ? (
                  <Check className="size-4 text-primary" aria-hidden />
                ) : (
                  <span className="size-4" aria-hidden />
                )}
                <span className="truncate">{workspace.name}</span>
              </span>
              <PlanBadge plan={workspace.plan} />
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
};
